/**
 * 移动端后台布局组件
 * 包含：顶部 NavBar、底部 TabBar 导航、内容区域
 */
import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  TabBar,
  NavBar,
} from 'antd-mobile';
import {
  AppOutline,
  UnorderedListOutline,
  TagOutline,
  UserOutline,
  SetOutline,
} from 'antd-mobile-icons';
import { useAuth } from '../../contexts/AuthContext';
import { useEffect } from 'react';

export default function MobileLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoggedIn } = useAuth();

  // 移除前台聊天插件（后台不需要）
  useEffect(() => {
    // 移除 Chatway 脚本
    const chatwayScript = document.getElementById('chatway');
    if (chatwayScript) {
      document.body.removeChild(chatwayScript);
    }
    // 移除 Chatway widget DOM 元素
    const chatwayWidgets = document.querySelectorAll('[id*="chatway"], [class*="chatway"]');
    chatwayWidgets.forEach((el) => {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    });
  }, []);

  // 未登录重定向到登录页
  if (!isLoggedIn) {
    navigate('/admin/m/login');
    return null;
  }

  // 底部导航配置
  const tabs = [
    {
      key: '/admin/m',
      title: '首页',
      icon: <AppOutline />,
    },
    {
      key: '/admin/m/orders',
      title: '订单',
      icon: <UnorderedListOutline />,
    },
    {
      key: '/admin/m/products',
      title: '商品',
      icon: <TagOutline />,
    },
    {
      key: '/admin/m/customers',
      title: '客户',
      icon: <UserOutline />,
    },
    {
      key: '/admin/m/more',
      title: '更多',
      icon: <SetOutline />,
    },
  ];

  // 根据当前路由匹配激活的 tab
  const getActiveKey = () => {
    const path = location.pathname;
    // 精确匹配
    const exactMatch = tabs.find(tab => path === tab.key);
    if (exactMatch) return exactMatch.key;
    // 前缀匹配（排除首页）
    const prefixMatch = tabs.find(tab =>
      tab.key !== '/admin/m' && path.startsWith(tab.key + '/')
    );
    if (prefixMatch) return prefixMatch.key;
    // 其他路径（如 inventory, discounts 等）归入"更多"
    if (path.startsWith('/admin/m/') && path !== '/admin/m') {
      return '/admin/m/more';
    }
    return '/admin/m';
  };

  const activeKey = getActiveKey();

  return (
    <div style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      {/* 顶部导航栏 - 使用深色风格 */}
      <NavBar
        back={null}
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 100,
          background: '#1a1a2e',
          color: '#fff',
        }}
      >
        <span style={{ fontWeight: 600, fontSize: 17, color: '#fff' }}>后台管理</span>
      </NavBar>

      {/* 内容区域 */}
      <div style={{ paddingBottom: 60 }}>
        <Outlet />
      </div>

      {/* 底部 TabBar - 使用深色风格 */}
      <TabBar
        activeKey={activeKey}
        onChange={(key) => navigate(key)}
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          borderTop: '1px solid #2d2d44',
          background: '#1a1a2e',
          '--color': '#8a8aa3',
          '--active-color': '#00d4aa',
        }}
      >
        {tabs.map((tab) => (
          <TabBar.Item key={tab.key} icon={tab.icon} title={tab.title} />
        ))}
      </TabBar>
    </div>
  );
}
